import Index from './index.vue'
import List from '@/modules/ReportCard/Curriculums/components/List.vue'

export default [
  {
    path: 'curriculums',
    name: 'curriculums',
    component: Index,
    title: 'curriculums',
    redirect: { name: 'curriculum-list' },
    children: [
      {
        path: 'list',
        name: 'curriculum-list',
        component: List,
      },
      
    ],
  },
]
